export const ElevationUpIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.557812 10.5575L9.49141 1.62465H2.875C2.70924 1.62465 2.55027 1.5588 2.43306 1.44159C2.31585 1.32438 2.25 1.16541 2.25 0.999652C2.25 0.833892 2.31585 0.67492 2.43306 0.55771C2.55027 0.440499 2.70924 0.374652 2.875 0.374652H11C11.1658 0.374652 11.3247 0.440499 11.4419 0.55771C11.5592 0.67492 11.625 0.833892 11.625 0.999652V9.12465C11.625 9.29041 11.5592 9.44938 11.4419 9.56659C11.3247 9.6838 11.1658 9.74965 11 9.74965C10.8342 9.74965 10.6753 9.6838 10.5581 9.56659C10.4408 9.44938 10.375 9.29041 10.375 9.12465V2.50825L1.44219 11.4418C1.38412 11.4999 1.31518 11.546 1.23931 11.5774C1.16344 11.6088 1.08212 11.625 1 11.625C0.917878 11.625 0.83656 11.6088 0.76069 11.5774C0.684819 11.546 0.615881 11.4999 0.557812 11.4418C0.499743 11.3838 0.453681 11.3148 0.422255 11.239C0.390828 11.1631 0.374652 11.0818 0.374652 10.9997C0.374652 10.9175 0.390828 10.8362 0.422255 10.7603C0.453681 10.6845 0.499743 10.6155 0.557812 10.5575Z"
        fill="#D9D9D9"
      />
    </svg>
  )
}
